export const APP_CSS = {
  ["[.main-content].left"]: "32px",
  ["[#sidebar].display"]: "flex",
};
